module.exports = __webpack_public_path__ + "media/images/about-hero-d4af2637c94c14e7065ec01afd4e448e.png";